module.exports = __webpack_public_path__ + "img/logo.cf5bc7b6.svg";